import SvgIcon, {
  SvgIconProps,
} from '@mui/material/SvgIcon';
import React from 'react';

export default function ConsentFormIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 13 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.3346 4.66634V4.53301C11.3346 3.4129 11.3346 2.85285 11.1166 2.42503C10.9249 2.0487 10.6189 1.74274 10.2426 1.55099C9.81479 1.33301 9.25474 1.33301 8.13463 1.33301H3.86797C2.74786 1.33301 2.18781 1.33301 1.75999 1.55099C1.38366 1.74274 1.0777 2.0487 0.885956 2.42503C0.667969 2.85285 0.667969 3.4129 0.667969 4.53301V11.4663C0.667969 12.5864 0.667969 13.1465 0.885956 13.5743C1.0777 13.9506 1.38366 14.2566 1.75999 14.4484C2.18781 14.6663 2.74786 14.6663 3.86797 14.6663H6.33464M6.33464 7.33301H3.33464M5.66797 9.99967H3.33464M8.66797 4.66634H3.33464M10.0013 11.9997V8.33301C10.0013 7.78072 10.449 7.33301 11.0013 7.33301C11.5536 7.33301 12.0013 7.78072 12.0013 8.33301V11.9997C12.0013 13.1042 11.1059 13.9997 10.0013 13.9997C8.89673 13.9997 8.0013 13.1042 8.0013 11.9997V9.33301"
        stroke="currentColor"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}
